<template>
  <div>
    <div class="header-text">
      <h1>券包管理-创建</h1>
      <div class="buttom-div">
        <el-button class="push-button" @click="preservation">创建</el-button>
        <el-button
          class="push-button"
          icon="iconfont icon-fanhui"
          @click="backHistory"
          >返回</el-button
        >
      </div>
    </div>
    <div>
      <el-card shadow="never">
        <!-- 表单 -->
        <div>
          <el-form
            size="small"
            :rules="CouponesMessageRlues"
            :model="CouponesMessage"
            ref="CouponesMessageRefs"
            label-width="150px"
          >
            <el-row>
              <el-col :span="12">
                <el-form-item prop="coupPacketName" label="劵包名称">
                  <el-input v-model="CouponesMessage.coupPacketName"></el-input>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="12">
                <el-form-item prop="SecuritiesList" label="券包内容">
                  <el-button size="small" @click="choiceVisible = true"
                    >选择劵库</el-button
                  >
                  <el-button size="small" @click="resetData"
                    >清空表格</el-button
                  >
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="16">
                <el-form-item>
                  <el-table
                    size="small"
                    class="table-style"
                    height="550px"
                    border
                    :row-class-name="tableRowClassName"
                    :header-cell-style="{
                      background: '#FCFBF2',
                      'text-align': 'center',
                      color: '#6C6839',
                      fontSize: '14px',
                    }"
                    :cell-style="{ 'text-align': 'center' }"
                    ref="multipleTable"
                    :data="CouponesMessage.SecuritiesList"
                    tooltip-effect="dark"
                    style="width: 100%"
                  >
                    <el-table-column type="index" width="50"> </el-table-column>
                    <el-table-column prop="couponsName" label="劵名称">
                    </el-table-column>
                    <el-table-column prop="couponsKindText" label="券类型">
                    </el-table-column>
                    <el-table-column prop="name" label="发放数量(张)">
                      <template slot-scope="scope">
                        <el-input
                          type="Number"
                          v-model="scope.row.IssuedQuantity"
                        ></el-input>
                      </template>
                    </el-table-column>
                    <el-table-column label="操作" align="center">
                      <template slot-scope="scope">
                        <el-button
                          type="text"
                          @click="Delete(scope.row)"
                          size="mini"
                          >删除</el-button
                        >
                      </template>
                    </el-table-column>
                  </el-table>
                </el-form-item>
              </el-col>
            </el-row>
          </el-form>
        </div>
        <div class="choice">
          <el-dialog title="选择劵库" :visible.sync="choiceVisible">
            <el-form size="small" label-width="100px">
              <el-row>
                <el-col :span="12">
                  <el-form-item label="券名称">
                    <el-input v-model="PageVolumeLibrary.couponsName">
                    </el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item label="券类型">
                    <div class="flex-between">
                      <el-select
                        style="width: 100%"
                        v-model="PageVolumeLibrary.couponsKind"
                      >
                        <el-option
                          v-for="(item, index) in CouponsType"
                          :key="index"
                          :label="item.label"
                          :value="item.id"
                        ></el-option>
                      </el-select>
                      <el-button
                        icon="iconfont icon-sousuo1"
                        @click="query"
                        size="mini"
                        >查询</el-button
                      >
                    </div>
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row>
                <el-col :span="15">
                  <el-form-item label="创建时间">
                    <el-date-picker
                      v-model="PageVolumeLibrary.datePicker1"
                      type="daterange"
                      start-placeholder="开始日期"
                      end-placeholder="结束日期"
                      :picker-options="pickerOptions"
                    >
                    </el-date-picker>
                  </el-form-item>
                </el-col>
              </el-row>
            </el-form>

            <div style="width: 100%; margin-top: 10px">
              <el-table
                height="450px"
                class="table-style"
                border
                :row-class-name="tableRowClassName"
                :header-cell-style="{
                  background: '#FCFBF2',
                  color: '#6C6839',
                  'text-align': 'center',
                }"
                :cell-style="{ 'text-align': 'center' }"
                ref="SelectmultipleTable"
                :data="SelectSecuritiesList"
                tooltip-effect="dark"
                v-el-table-infinite-scroll="SelectPageTouchTheBottom"
                infinite-scroll-disabled="SelectinfiniteScrollDisabledIs"
                v-loading="PageVolumeLibrary.Loading"
              >
                <el-table-column label width="50" type="index">
                </el-table-column>
                <el-table-column type="selection" width="50"> </el-table-column>
                <el-table-column prop="couponsName" label="劵名称">
                </el-table-column>
                <el-table-column prop="innerCoupName" label="劵后台名称">
                </el-table-column>
                <el-table-column
                  prop="couponsKindText"
                  width="100"
                  label="劵类型"
                >
                </el-table-column>
                <el-table-column prop="createUserName" label="创建人">
                </el-table-column>
                <el-table-column
                  prop="createTimeStr"
                  width="180px"
                  label="创建时间"
                >
                </el-table-column>
              </el-table>
              <el-alert
                v-if="PagesSelectIsMore"
                title="没有更多数据了!"
                type="warning"
                center
                :closable="false"
              >
              </el-alert>
            </div>
            <span slot="footer" class="dialog-footer">
              <el-button @click="ConfirmSelection">确 定</el-button>
              <el-button @click="choiceVisible = false">取 消</el-button>
            </span>
          </el-dialog>
        </div>
      </el-card>
    </div>
  </div>
</template>

<script>
import {
  couponsGroupList,
  couppacketInsert,
  couppacketview,
} from "@/api/couponsDepot.js";
import { getcpyNo } from "@/utils/auth";
import { mapState } from "vuex";
export default {
  data() {
    return {
      CouponsType: [
        {
          label: "全部",
          id: "",
        },
        {
          label: "现金券",
          id: 0,
        },
        {
          label: "折扣券",
          id: 1,
        },
        {
          label: "礼品券",
          id: 2,
        },
        {
          label: "异业券",
          id: 3,
        },
      ],
      SelectSecuritiesList: [],
      PageVolumeLibrary: {
        datePicker1: "",
        pageNo: 1,
        pageSize: 50,
        couponsName: "",
        couponsKind: "",
        createEndDay: "",
        createStartDay: "",
        pages: 2,
        Loading: true,
      },
      pickerOptions: {
        shortcuts: [
          {
            text: "最近一周",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
              picker.$emit("pick", [start, end]);
            },
          },
          {
            text: "最近一个月",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
              picker.$emit("pick", [start, end]);
            },
          },
          {
            text: "最近三个月",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
              picker.$emit("pick", [start, end]);
            },
          },
          {
            text: "最近一年",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 365);
              picker.$emit("pick", [start, end]);
            },
          },
        ],
      },
      choiceVisible: false,

      CouponesMessage: {
        coupPacketName: "",
        SecuritiesList: [], //选择后的数据
      },
      CouponesMessageRlues: {
        coupPacketName: [
          { required: true, message: "请输入劵包名称", trigger: "blur" },
        ],
        SecuritiesList: [
          {
            type: "array",
            required: true,
            message: "请至少选择一个条卷库数据",
            trigger: "change",
          },
        ],
      },
    };
  },
  computed: {
    ...mapState({
      CouponsSelectChang: (state) => state.user.CouponsSelectChang,
    }),
    PagesSelectIsMore() {
      return this.PageVolumeLibrary.pageNo >= this.PageVolumeLibrary.pages;
    },
    SelectinfiniteScrollDisabledIs() {
      return this.PageVolumeLibrary.Loading || this.PagesSelectIsMore;
    },
  },
  created() {
    this.RcouponsGroupList();
    this.Rcouppacketview();
  },
  methods: {
    Rcouppacketview() {
      let data = require("qs").stringify({
        coupPacketID: this.CouponsSelectChang.coupPacketID,
      });
      couppacketview(data).then((res) => {
        if (res.success) {
          this.CouponesMessage = res.data;
          let SecuritiesList = [];
          res.line.forEach((item) => {
            item.couponsKindText = this.returnCouponsKindText(
              parseInt(item.couponsKind)
            );
            item.IssuedQuantity = item.qty;
            SecuritiesList.push(item);
          });
          this.CouponesMessage.SecuritiesList = SecuritiesList;
          console.log("res", this.CouponesMessage);
        } else {
          this.$message({
            message: res.message,
            type: "warning",
          });
        }
      });
    },
    resetData() {
      if (this.CouponesMessage.SecuritiesList.length <= 0) {
        return false;
      }
      this.$confirm("此操作将删除已选择的卷库, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
           this.CouponesMessage.SecuritiesList.splice(0,this.CouponesMessage.SecuritiesList.length);
          this.$message({
            type: "success",
            message: "删除成功!",
          });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除",
          });
        });
    },
    Delete(row) {
      this.CouponesMessage.SecuritiesList.forEach((item, index) => {
        if (item.couponsGrpID == row.couponsGrpID) {
          this.CouponesMessage.SecuritiesList.splice(index, 1);
        }
      });
    },
    ConfirmSelection() {
      this.CouponesMessage.SecuritiesList =
        this.CouponesMessage.SecuritiesList.concat(
          ...this.$refs.SelectmultipleTable.selection
        );
      const res = new Map();
      this.CouponesMessage.SecuritiesList =
        this.CouponesMessage.SecuritiesList.filter(
          (a) => !res.has(a.couponsGrpID) && res.set(a.couponsGrpID, 1)
        );
      this.$refs.SelectmultipleTable.clearSelection();
      this.choiceVisible = false;
    },
    renderTime(date) {
      //格式化时间
      if (date != null) {
        var dateee = new Date(date).toJSON();
        return new Date(+new Date(dateee) + 8 * 3600 * 1000)
          .toISOString()
          .replace(/T/g, " ")
          .replace(/\.[\d]{3}Z/, "");
      } else {
        return "";
      }
    },
    query() {
      if (
        this.PageVolumeLibrary.datePicker1 &&
        this.PageVolumeLibrary.datePicker1.length > 0
      ) {
        this.PageVolumeLibrary.createStartDay = this.renderTime(
          this.PageVolumeLibrary.datePicker1[0]
        ).substring(0, 10);
        this.PageVolumeLibrary.createEndDay = this.renderTime(
          this.PageVolumeLibrary.datePicker1[1]
        ).substring(0, 10);
      } else {
        this.PageVolumeLibrary.createStartDay = "";
        this.PageVolumeLibrary.createEndDay = "";
      }
      this.PageVolumeLibrary.pageNo = 1;
      this.PageVolumeLibrary.Loading = true;
      this.SelectSecuritiesList = [];
      this.RcouponsGroupList();
    },
    SelectPageTouchTheBottom() {
      this.PageVolumeLibrary.Loading = true;
      this.PageVolumeLibrary.pageNo++;
      this.RcouponsGroupList();
    },
    returnCouponsKindText(type) {
      let text = "";
      switch (type) {
        case 0:
          text = "现金券";
          break;
        case 1:
          text = "折扣券";
          break;
        case 2:
          text = "礼品券";
          break;
        case 3:
          text = "异业券";
          break;
      }
      return text;
    },
    RcouponsGroupList() {
      let data = require("qs").stringify({
        cpyNo: getcpyNo,
        pageNo: this.PageVolumeLibrary.pageNo,
        pageSize: this.PageVolumeLibrary.pageSize,
        couponsName: this.PageVolumeLibrary.couponsName,
        couponsKind: this.PageVolumeLibrary.couponsKind,
        createEndDay: this.PageVolumeLibrary.createEndDay,
        createStartDay: this.PageVolumeLibrary.createStartDay,
        state:0,
      });
      couponsGroupList(data).then((res) => {
        if (res.success) {
          this.PageVolumeLibrary.pages = res.data.pages;
          res.data.list.forEach((item) => {
            item.couponsKindText = this.returnCouponsKindText(
              parseInt(item.couponsKind)
            );
            item.IssuedQuantity = 0;
          });
          this.SelectSecuritiesList = this.SelectSecuritiesList.concat(
            res.data.list
          );
        } else {
          this.$message.error(res.message);
        }
        this.PageVolumeLibrary.Loading = false;
      });
    },
    preservation() {
      this.$refs.CouponesMessageRefs.validate((valid) => {
        if (!valid) return true;
        this.$confirm("是否确认保存数据", "确认信息", {
          distinguishCancelAndClose: true,
          confirmButtonText: "保存",
          cancelButtonText: "放弃",
        })
          .then(() => {
            let data = [];
            this.CouponesMessage.SecuritiesList.forEach((item) => {
              data.push({
                couponsGrpID: item.couponsGrpID,
                qty: item.IssuedQuantity,
              });
            });
            couppacketInsert(data, this.CouponesMessage.coupPacketName).then(
              (res) => {
                this.$message({
                  message: "保存成功",
                  type: "success",
                });
                this.backHistory();
              }
            );
          })
          .catch(() => {
            this.$message({
              type: "info",
              message: "放弃保存",
            });
          });
      });
    },
    backHistory() {
      this.$router.go(-1); //返回上一层
    },
    // 判断如果是单行就变黄色双行是白色
    tableRowClassName({ rowIndex }) {
      if (rowIndex % 2 === 1) {
        return "warning-row";
      }
      return "";
    },
  },
};
</script>
<style lang="scss" scoped>
.table-stylePages {
  position: relative;
  width: 100%;
  max-height: calc(100vh - 22.5rem);
  overflow: auto;
}
.dialog-footer {
  display: flex;
  justify-content: flex-end;
}
.push-button {
  width: 100px;
  background-color: #e9e7d3;
}
.buttom-div {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  width: 250px;
  align-content: center;
}
/deep/.table-stylePages {
  .el-input--small .el-input__inner {
    border: 0 !important;
    text-align: center;
  }
}
.header-text {
  margin-bottom: 5px;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  height: 50px;
  margin-top: 20px;
  color: #76734f;
}

::v-deep {
  // 表格隔行变色
  .el-table .warning-row {
    background: #fcfbf2;
  }

  .el-table .success-row {
    background: #ffffff;
  }
  // 创建弹窗样式
  .choice {
    .el-dialog__header,
    .el-message-box__header {
      height: 44px;
      background: #f3f1dd;
      display: flex;
      justify-content: space-between;
      align-items: center;
      padding: 0 20px;
    }
    .el-dialog__title,
    .el-message-box__title {
      color: #6c6937;
      font-weight: 700;
      font-size: 14px !important;
    }

    /* Dialog对话框 公共部分样式 End*/

    .el-tabs__item {
      color: #6c6937;
    }
    .el-dialog__footer {
      height: 60px;
      text-align: center;
      background-color: #f2f2f2;
    }

    .el-dialog__body {
      padding: 10px 20px;
    }

    .el-button:hover {
      background-color: #b6b388;
    }
  }
}
</style>
